import styled, { css } from 'styled-components';
import { ITheme } from '../../../styles/theme';
import CloseMark from '@/assets/icons/closeMark.svg?react';

const button = css`
  display: flex;
  height: 48px;
  margin: 0;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;
`;

interface IFooterElem {
  theme: ITheme;
  hasBorder: boolean;
}

export const FooterElem = styled.footer<IFooterElem>`
  ${({ theme, hasBorder }) => `
    display: flex;
    height: 80px;
    padding: ${theme.layout.spacing.mili} ${theme.layout.spacing.centy};
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.layout.spacing.centy};
    border-top: ${hasBorder ? `1px solid ${theme.colors.neutral.primary[30]}` : 'none'};
  `};
`;

export const CancelButton = styled.button`
  ${({ theme }) => `
    ${button};
    padding: ${theme.layout.spacing.mikro} ${theme.layout.spacing.centy};
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[100]};
    color: ${theme.colors.primary[100]};
  `};
`;

export const CloseIcon = styled(CloseMark)`
  ${({ theme }) => `
    width: 20px;
    height: 20px;

    path {
      fill: ${theme.colors.primary[100]};
    }
  `};
`;

export const ConfirmButton = styled.button`
  ${({ theme }) => `
    ${button};
    padding: ${theme.layout.spacing.mikro} ${theme.layout.spacing.centy};
    background: ${theme.colors.primary[100]};
    border: none;
    border-radius: 8px;
    color: ${theme.colors.neutral.primary[5]};
  `};
`;
